<template>
  <button
    :class="btnClass"
    :disabled="loading"
    @click="$emit('click',$event)"
  >
    <hc-icon
      :icon="icon"
      v-if="icon && !loading"
      class="icon"
    ></hc-icon>
    <!-- loading的icon -->
    <hc-icon
      icon="loading"
      v-if="loading"
      class="icon loading-icon"
    ></hc-icon>
    <span v-if="this.$slots.default">
      <slot></slot>
    </span>
  </button>
</template>
<script>
import { NAME_PRE } from '@/packages/constant/index';

const typeArr = ['primary', 'success', 'warning', 'danger', 'info'];
const positionArr = ['left', 'right'];
const sizeArr = ['mini', 'small', 'medium'];
export default {
  name: `${NAME_PRE}-button`,
  props: {
    type: {
      type: String,
      default: '',
      validator(type) {
        if (type && !typeArr.includes(type)) {
          console.error(`type 类型只能是${typeArr.join('、')}中的一个`);
        }
        return true;
      },
    },

    icon: {
      type: String,
    },

    position: {
      type: String,
      default: 'left',
      validator(po) {
        if (po && !positionArr.includes(po)) {
          console.error(`position 类型只能是${positionArr.join('、')}中的一个`);
        }
        return true;
      },
    },
    size: {
      type: String,
      default: '',
      validator(size) {
        if (size && !sizeArr.includes(size)) {
          console.error(` size只能是${sizeArr.join('、')}中的一个`);
        }
        return true;
      },
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // NAME_PRE,
    };
  },

  computed: {
    btnClass() {
      const classes = [`${NAME_PRE}-button`];
      if (this.type) {
        classes.push(`${NAME_PRE}-button-${this.type}`);
      }

      if (this.position) {
        classes.push(`${NAME_PRE}-button-${this.position}`);
      }

      if (this.size) {
        classes.push(`${NAME_PRE}-button-${this.size}`);
      }
      return classes;
    },
  },
};
</script>
